export default __webpack_public_path__ + "static/media/Gustavo.460dfbaa.png";